module.exports = __webpack_public_path__ + "img/Avatar-10.7d9053f3.gif";